export default __webpack_public_path__ + "static/media/gpunks20.c1cda2da.png";